import React, { useState } from "react";

/** */
import { Box } from "@mui/material";

/** Router and swiching  */
import { Route, Switch } from "react-router-dom";
import { PrivateRoute } from "./services/auth";

/** Redux */
import { useSelector } from "react-redux";
import { useTitle } from "./components/commons/customHook";

/** const and styles */
import "./App.css";
import { drawerWidth } from "./components/styles";

//Layout Components
import Header from "./components/layout/headerNavbar.component";
import Footer from "./components/layout/footer.component";
import NotFound from "./components/layout/notfound.component";
import SideBar from "./components/layout/sidebar.component";

//Profile Components
import Login from "./components/profile/login.component";
import ChangePassword from "./components/pages/users/changePassword.component";
import Profile from "./components/pages/profile/profile.component";

//Admin Components
import User from "./components/pages/users/user.component";
import CreateUser from "./components/pages/users/createuserbutton.component";
import EditUser from "./components/pages/users/edituser.component";
import UserGroup from "./components/pages/groupusers/usergroup.component";
import CreateUserGroup from "./components/pages/groupusers/createuserbuttongroup.component";
import EditUserGroup from "./components/pages/groupusers/editusergroup.component";

//Business Components
import Dashboard from "./components/pages/dashboard.component";
import Customers from "./components/pages/customers.component";
import Organization from "./components/pages/organization/organization.component";
import Department from "./components/pages/deparment/department";
import SaleOrder from "./components/pages/saleorder/saleorder.component";

import Prices from "./components/pages/prices/prices.component";
import Currency from "./components/pages/prices/currency.component";
import ExtPrice from "./components/pages/prices/extprice";

import Product from "./components/pages/products/product.component";
import ProductUnit from "./components/pages/products/productunit.component";
import Aircraft from "./components/pages/aircraft/aircraft.component";
import MasterData from "./components/pages/masterdata/masterdata.component";
import Flight from "./components/pages/flight/flight.component";
import SaleType from "./components/pages/masterdata/saletype.component";
import LoadingType from "./components/pages/masterdata/loadingtype.component";

import Banks from "./components/pages/banks/banks.component";
import CreateBank from "./components/pages/banks/createrbank.coponent";
import EditBank from "./components/pages/banks/editbank.component";

import InvoiceForm from "./components/pages/invoiceform/invoiceform.componnet";
import GroupVehicles from "./components/pages/transportation/groupvehicles.components";
import Vehicles from "./components/pages/transportation/vehicle.component";
import CreateVehicle from "./components/pages/transportation/createvehicle.component";

import GrpSparepart from "./components/pages/sparepart/grp_sparepart";
import Sparepart from "./components/pages/sparepart/sparepart";

import Driver from "./components/pages/transportation/driver.component";

import Provider from "./components/pages/provider/provider.component";
import CreateProvider from "./components/pages/provider/createProvider.component";

import Inventory from "./components/pages/inventory/inventory.component";
import Airport from "./components/pages/airport/airport";

import SaleArea from "./components/pages/salearea/salearea.component";
import LTP from "./components/pages/ltp/ltp.component";
import Tanks from "./components/pages/tank/tank.component";

import Acsreg from "./components/pages/aircraft/acsreg";
import PO from "./components/pages/po";
import AppId from "./components/pages/appid";
import Ctmdocs from "./components/pages/ctmdocs";

import Bact from "./components/pages/bact";
import Synctime from "./components/pages/synctime";
import Subso from "./components/pages/subso";
import Config from "./components/pages/Config";

/** PI */
// import PI from "./components/pages/pi/PI.component";
import PI from "./components/pages/pi";
import CreatePI from "./components/pages/pi/createPI";

/** Fuel LogBox */
import FuelLogbox from "./components/pages/fuelTicket/fuellogblox";

/** Fuel Ticket */
import FuelTicket from "./components/pages/fuelTicket/fuelticket.component";
import CreateAirFT from "./components/pages/fuelTicket/createAirFT";
import CreateTruckFT from "./components/pages/fuelTicket/createTruckFT";
import CreateRefuelerTruckFT from "./components/pages/fuelTicket/createRefuelerTruckFT";
import CreateStationTicket from "./components/pages/fuelTicket/createStationFT";

/** Receipt */
import TicketList from "./components/pages/ticket/ticket";
import ImpProcess from "./components/pages/ticket/impProcess.component";
import CreateTicket from "./components/pages/ticket/ticketCrt";
import RptTicket from "./components/pages/ticket/ticketRpt";
import KT0401 from "./components/pages/ticket/kt0401.component";
import RPTImpTruck from "./components/pages/report/rptimptruck";

/** Inv */
import Invoices from "./components/pages/invoices/inv";
import CreateAirInv from "./components/pages/invoices/invCrtAir";
import CreateShipInv from "./components/pages/invoices/invCrtShip";
import CreateTruckInvoice from "./components/pages/invoices/invCrtTruck";
import CreateOtherInvoice from "./components/pages/invoices/invOther/invCrtOther";
import AdjustInv from "./components/pages/invoices/invAdj";
import ErpInv from "./components/pages/invoices/invErp";
import AdjustInvErp from "./components/pages/invoices/invErpAdj";
import ReplaceInvErp from "./components/pages/invoices/invErpReplace";

import RPTSumTotalInv from "./components/pages/report/rptsumtotalinv";
import RPTTotalInv from "./components/pages/report/rpttotalinv";
import RPTTotalInvByBranch from "./components/pages/report/rpttotalinvbybranch";

/** CI */
import CI from "./components/pages/ci";
import CreateCI from "./components/pages/ci/ciCrt";
import RptExpCI from "./components/pages/report/rptExpCi";

/** M23 */
import CreateM23 from "./components/pages/m23/createM23";
import M23 from "./components/pages/m23";
import RPTM23Truck from "./components/pages/report/rptm23truck";

/** Log */
import LogERP from "./components/pages/log/erp";
import LogVNPT from "./components/pages/log/vnpt";
import LogEmail from "./components/pages/log/email";

/** Ext Receipt */
import Extrpt from "./components/pages/extrpt";
import Extapies from "./components/pages/extapies";

/** B5 */
import B5 from "./components/pages/b5";
import CreateB5 from "./components/pages/b5/create";

/** Debt */
import Erppt from "./components/pages/finance/erppt.component";
import Debt from "./components/pages/finance/debt.component";
import CustDebt from "./components/pages/finance/custdebt.component";
import SaleDebt from "./components/pages/finance/saledebt.component";
import RptDebt from "./components/pages/report/rptDebt";
import RptErppt from "./components/pages/report/rptErppt";
import Prepaid from "./components/pages/prepaid";

const App = () => {
  useTitle();
  const profile = useSelector((state) => state.user.data);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarOpen1, setSidebarOpen1] = useState(false);
  return (
    <div className="App">
      <Box sx={{ width: { xl: profile && sidebarOpen1 && drawerWidth }, flexShrink: { lg: 0 } }}>
        <SideBar open={Boolean(profile && sidebarOpen)} open1={Boolean(profile && sidebarOpen1)} onClose1={() => setSidebarOpen1(false)} onClose={() => setSidebarOpen(false)} />
      </Box>
      <Box sx={{ flexGrow: 1, width: profile && sidebarOpen1 ? { xl: `calc(100% - ${drawerWidth})` } : "100%", marginLeft: { xl: profile && sidebarOpen1 && drawerWidth } }}>
        <Header
          sx={{ width: { xl: `calc(100% - ${profile && sidebarOpen1 && drawerWidth})` }, marginLeft: { xl: profile && sidebarOpen1 && drawerWidth } }}
          onMenuClick={() => setSidebarOpen((prev) => !prev)}
          onMenuClick1={() => setSidebarOpen1((prev) => !prev)}
        />
        <div style={{ padding: "50px 0px" }}>
          <Switch>
            {/* In router, no change position */}
            <Route exact path="/login" component={Login} />
            <PrivateRoute exact path="/" component={Dashboard} />

            {/* <PrivateRoute exact path="/createfuelbatchticket" component={CreateFuelBatchTicket} /> */}

            <PrivateRoute exact path="/impprocess" component={ImpProcess} />

            {/* <PrivateRoute exact path='/createticket' component={CreateTicket} /> */}

            {/* <PrivateRoute exact path="/truck" component={Truck} /> */}

            <PrivateRoute exact path="/custdebt" component={CustDebt} />
            <PrivateRoute exact path="/masterdata" component={MasterData} />

            {/* Sell */}
            <PrivateRoute exact path={["/fuelticket", "/fuelticket/:fuelticketid"]} component={FuelTicket} />
            <PrivateRoute exact path={["/fuelticket/replace/airft/:ticketid", "/fuelticket/create/airft"]} component={CreateAirFT} />
            <PrivateRoute exact path={["/fuelticket/create/truckft", "/fuelticket/replace/truckft/:ticketid"]} component={CreateTruckFT} />
            <PrivateRoute exact path={["/fuelticket/create/refuelertruckft", "/fuelticket/replace/refuelertruckft/:ticketid"]} component={CreateRefuelerTruckFT} />
            <PrivateRoute exact path={["/fuelticket/create/stationft", "/fuelticket/replace/stationft/:ticketid"]} component={CreateStationTicket} />

            <PrivateRoute exact path={["/invoices", "/invoices/:invoiceId"]} component={Invoices} />
            <PrivateRoute exact path={["/invoices/create/airinv", "/invoices/edit/airinv/:invoiceid"]} component={CreateAirInv} />
            <PrivateRoute exact path={["/invoices/create/ship", "/invoices/edit/ship/:invoiceid"]} component={CreateShipInv} />
            <PrivateRoute exact path={["/invoices/create/truck", "/invoices/edit/truck/:invoiceid"]} component={CreateTruckInvoice} />
            <PrivateRoute exact path={["/invoices/create/other", "/invoices/edit/other/:invoiceid"]} component={CreateOtherInvoice} />
            <PrivateRoute exact path={["/invoices/adj/:invoiceid"]} component={AdjustInv} />

            <PrivateRoute exact path={["/erpinv", "/erpinv/:invoiceId"]} component={ErpInv} />
            <PrivateRoute exact path={["/erpinv/adj/:invoiceId"]} component={AdjustInvErp} />
            <PrivateRoute exact path={["/erpinv/replace/:invoiceId"]} component={ReplaceInvErp} />

            <PrivateRoute exact path="/ci/create" component={CreateCI} />
            <PrivateRoute exact path={["/ci", "/ci/:id"]} component={CI} />

            <PrivateRoute exact path="/report/rptsumtotalinv" component={RPTSumTotalInv} />
            <PrivateRoute exact path="/report/rpttotalinv" component={RPTTotalInv} />
            <PrivateRoute exact path="/report/rpttotalinvbybranch" component={RPTTotalInvByBranch} />

            {/* JET A1 Bought */}
            <PrivateRoute exact path={["/m23/create", "/m23/:ticketid/replace"]} component={CreateM23} />
            <PrivateRoute exact path={["/m23", "/m23/:ticketid"]} component={M23} />
            <PrivateRoute exact path="/report/rptm23truck" component={RPTM23Truck} />

            {/* Internal Transfer */}
            <PrivateRoute exact path={["/extrpt", "/extrpt/:id"]} component={Extrpt} />
            <PrivateRoute exact path="/report/rptimptruck" component={RPTImpTruck} />

            <PrivateRoute exact path={["/ticket", "/ticket/:ticketId"]} component={TicketList} />
            <PrivateRoute exact path={["/editticket/:ticketid", "/createticket"]} component={CreateTicket} />

            <PrivateRoute exact path={["/b5", "/b5/:id"]} component={B5} />
            <PrivateRoute exact path={["/editb5/:id", "/createb5"]} component={CreateB5} />
            <PrivateRoute exact path="/rptticket" component={RptTicket} />

            {/* Input Invoice */}
            <PrivateRoute exact path="/pi">
              <PI type={0} />
            </PrivateRoute>
            <PrivateRoute exact path="/pi1">
              <PI type={1} />
            </PrivateRoute>
            <PrivateRoute exact path="/pi2">
              <PI type={2} />
            </PrivateRoute>
            <PrivateRoute exact path="/pi/create" component={CreatePI} />

            {/* Debt Management */}
            <PrivateRoute exact path={["/subso"]} component={Subso} />
            <PrivateRoute exact path={["/erppt", "/erppt/:id"]} component={Erppt} />
            <PrivateRoute exact path="/report/erppt" component={RptErppt} />
            <PrivateRoute exact path="/debt" component={Debt} />
            <PrivateRoute exact path="/report/debt" component={RptDebt} />
            <PrivateRoute exact path="/report/rptci" component={RptExpCI} />
            <PrivateRoute exact path="/saledebt" component={SaleDebt} />
            <PrivateRoute exact path="/prepaid" component={Prepaid} />

            {/* Technical Management  */}
            <PrivateRoute exact path="/fuellogbox" component={FuelLogbox} />
            <PrivateRoute exact path="/kt0401" component={KT0401} />

            {/* Master Data */}
            <PrivateRoute exact path="/inventory" component={Inventory} />
            <PrivateRoute exact path="/tank" component={Tanks} />
            <PrivateRoute exact path="/customers" component={Customers} />
            <PrivateRoute exact path="/invoice-form" component={InvoiceForm} />
            <PrivateRoute exact path="/ltp" component={LTP} />
            <PrivateRoute exact path="/sale-order" component={SaleOrder} />
            <PrivateRoute exact path="/po" component={PO} />
            <PrivateRoute exact path="/ctmdocs" component={Ctmdocs} />

            <PrivateRoute exact path="/price" component={Prices} />
            <PrivateRoute exact path="/currency" component={Currency} />
            <PrivateRoute exact path="/extprice" component={ExtPrice} />

            <PrivateRoute exact path={["/banks", "/banks/:id"]} component={Banks} />
            <PrivateRoute exact path="/editbank/:bankid" component={EditBank} />
            <PrivateRoute exact path="/createbank" component={CreateBank} />

            <PrivateRoute exact path={["/bact", "/bact/:bactId"]} component={Bact} />
            <PrivateRoute exact path="/product" component={Product} />
            <PrivateRoute exact path="/product-unit" component={ProductUnit} />
            <PrivateRoute exact path="/airport" component={Airport} />
            <PrivateRoute exact path="/flight" component={Flight} />
            <PrivateRoute exact path="/aircraft" component={Aircraft} />
            <PrivateRoute exact path="/acsreg" component={Acsreg} />

            <PrivateRoute exact path="/vehiclegroup" component={GroupVehicles} />
            <PrivateRoute exact path="/vehicle" component={Vehicles} />
            <PrivateRoute exact path="/createvehicle" component={CreateVehicle} />

            <PrivateRoute exact path="/grp-sparepart" component={GrpSparepart} />
            <PrivateRoute exact path="/sparepart" component={Sparepart} />

            <PrivateRoute exact path="/provider" component={Provider} />
            <PrivateRoute exact path="/provider/create" component={CreateProvider} />
            <PrivateRoute exact path="/driver" component={Driver} />

            <PrivateRoute exact path="/salearea" component={SaleArea} />
            <PrivateRoute exact path="/saletype" component={SaleType} />
            <PrivateRoute exact path="/loadingtype" component={LoadingType} />

            <PrivateRoute exact path="/appid" component={AppId} />

            {/* Organization */}
            <PrivateRoute exact path="/organization" component={Organization} />
            <PrivateRoute exact path="/department" component={Department} />
            <PrivateRoute exact path="/usergroup" component={UserGroup} />
            <PrivateRoute exact path="/editusergroup/:usergroupid" component={EditUserGroup} />
            <PrivateRoute exact path="/createusergroup" component={CreateUserGroup} />
            <PrivateRoute exact path="/user" component={User} />
            <PrivateRoute exact path="/edituser/:userid" component={EditUser} />
            <PrivateRoute exact path="/createuser" component={CreateUser} />
            <PrivateRoute exact path="/changepassword/:userid" component={ChangePassword} />
            <PrivateRoute exact path="/profile" component={Profile} />

            {/* System */}
            <PrivateRoute exact path={["/config", "/config/:id"]} component={Config} />
            <PrivateRoute exact path={["/extapies", "/extapies/:id"]} component={Extapies} />
            <PrivateRoute exact path={["/synctime"]} component={Synctime} />

            {/* Log */}
            <PrivateRoute exact path="/log/erp" component={LogERP} />
            <PrivateRoute exact path="/log/vnpt" component={LogVNPT} />
            <PrivateRoute exact path="/log/email" component={LogEmail} />

            <PrivateRoute exact path="/err404" component={NotFound} />
          </Switch>
        </div>
        <Footer />
      </Box>
    </div>
  );
};
export default App;
